import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class ArticleFilterValue extends BaseModel {
  static override constructorName = 'ArticleFilterValue'

  id: number = 0
  name: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(ArticleFilterValue)
